export default __webpack_public_path__ + "static/media/terrace1.ff7ce6cf.jpg";